import axios, { AxiosHeaders } from 'axios';

const Environment = process.env.REACT_APP_ENV;
const Prod = process.env.REACT_APP_PROD_BASE_URL;
const ProdBot = process.env.REACT_APP_PROD_CHATBOT_URL;
const ProdToken = process.env.REACT_APP_AUTH_TOKEN_PROD;

const Stage = process.env.REACT_APP_STAGE_BASE_URL;
const StageBot = process.env.REACT_APP_STAGE_CHATBOT_URL;
const StageToken = process.env.REACT_APP_AUTH_TOKEN_STAGE;

export const getBaseURL = () => (Environment === 'staging' ? Stage : Prod);
export const getToken = () => (Environment === 'staging' ? StageToken : ProdToken);
export const getBotBaseURL = () => (Environment === 'staging' ? StageBot : ProdBot);

const Api = axios.create({
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'Access-Control-Allow-Origin': '*',
    AccessControlAllowMethods: 'GET, POST, PUT, DELETE, OPTIONS',
    'Cache-Control': 'no-cache',
    'X-Requested-With': 'XMLHttpRequest'
  },
  withCredentials: false
});

Api.interceptors.request.use(
  (reqConfig) => {
    reqConfig.baseURL = getBaseURL();
    const token = getToken();
    if (token) {
      const headers = new AxiosHeaders(reqConfig.headers);
      headers.set('Authorization', `Bearer ${token}`);
      reqConfig.headers = headers;
    }
    return reqConfig;
  },
  (error) => Promise.reject(error)
);

export default Api;
